// R-audit-2026-09-20 P0-3: 路由级登录守卫,未登录用户直接 hit 受保护路由时跳转登录页。
// - 配合 App.jsx 顶层 `if (!user) return <Login />` 形成两道防线:顶层拦截常规导航,
//   RequireAuth 防御 useAuth context 尚未恢复 / 异步 race 时直接 hit 路由。
// - 不做模块权限(那是 RequireModule 的职责),只校验登录态。

import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return <div style={{ padding: 40, textAlign: 'center', color: '#595959' }}>加载中...</div>
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return children
}
